// 校验手机号
var checkPhone = (rule, value, callback) => {
  const regPhone = /^1[3-9]\d{9}$/
  if (regPhone.test(value)) {
    return callback()
  } else {
    callback(new Error('请输入合法的手机号'))
  }
}
export default {
  checkPhone
}
